<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-6 lg:col-5">
              <div class="">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-2xl text-primary font-bold">
                      Add New Applicants
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="card nice-shadow-18">
              <div>
                <form
                  ref="observer"
                  tag="form"
                  @submit.prevent="startSaveRecord()"
                  @reset="resetForm"
                >
                  <div class="grid">
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Application Ref</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlapplication_ref"
                            v-model.trim="formData.application_ref"
                            label="Application Ref"
                            type="text"
                            placeholder="Enter Application Ref"
                            class="w-full"
                            :class="getErrorClass('application_ref')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Is Fee Paying</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlis_fee_paying"
                            v-model.trim="formData.is_fee_paying"
                            label="Is Fee Paying"
                            type="text"
                            placeholder="Enter Is Fee Paying"
                            class="w-full"
                            :class="getErrorClass('is_fee_paying')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Pass To Affiliate</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlpass_to_affiliate"
                            v-model.trim="formData.pass_to_affiliate"
                            label="Pass To Affiliate"
                            type="text"
                            placeholder="Enter Pass To Affiliate"
                            class="w-full"
                            :class="getErrorClass('pass_to_affiliate')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Title</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltitle"
                            v-model.trim="formData.title"
                            label="Title"
                            type="text"
                            placeholder="Enter Title"
                            class="w-full"
                            :class="getErrorClass('title')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Firstname</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirstname"
                            v-model.trim="formData.firstname"
                            label="Firstname"
                            type="text"
                            placeholder="Enter Firstname"
                            class="w-full"
                            :class="getErrorClass('firstname')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Lastname</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrllastname"
                            v-model.trim="formData.lastname"
                            label="Lastname"
                            type="text"
                            placeholder="Enter Lastname"
                            class="w-full"
                            :class="getErrorClass('lastname')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Othernames</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlothernames"
                            v-model.trim="formData.othernames"
                            label="Othernames"
                            type="text"
                            placeholder="Enter Othernames"
                            class="w-full"
                            :class="getErrorClass('othernames')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Hometown</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlhometown"
                            v-model.trim="formData.hometown"
                            label="Hometown"
                            type="text"
                            placeholder="Enter Hometown"
                            class="w-full"
                            :class="getErrorClass('hometown')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Hometown Region</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlhometown_region"
                            v-model.trim="formData.hometown_region"
                            label="Hometown Region"
                            type="text"
                            placeholder="Enter Hometown Region"
                            class="w-full"
                            :class="getErrorClass('hometown_region')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Country</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlcountry"
                            v-model.trim="formData.country"
                            label="Country"
                            type="text"
                            placeholder="Enter Country"
                            class="w-full"
                            :class="getErrorClass('country')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Dial Code</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrldial_code"
                            v-model.trim="formData.dial_code"
                            label="Dial Code"
                            type="text"
                            placeholder="Enter Dial Code"
                            class="w-full"
                            :class="getErrorClass('dial_code')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Primary Telephone</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlprimary_telephone"
                            v-model.trim="formData.primary_telephone"
                            label="Primary Telephone"
                            type="text"
                            placeholder="Enter Primary Telephone"
                            class="w-full"
                            :class="getErrorClass('primary_telephone')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Gender</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <div
                            class="field-radiobutton"
                            v-for="option of $menus.genderItems"
                            :key="option.value"
                          >
                            <RadioButton
                              :class="getErrorClass('gender')"
                              :id="option.value"
                              name="ctrlgender"
                              :value="option.value"
                              v-model="formData.gender"
                            />
                            <label :for="option.value"
                              >{{ option.label }}
                            </label>
                          </div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Religious Denomination
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlreligious_denomination"
                            v-model.trim="formData.religious_denomination"
                            label="Religious Denomination"
                            type="text"
                            placeholder="Enter Religious Denomination"
                            class="w-full"
                            :class="getErrorClass('religious_denomination')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Marital Status</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmarital_status"
                            v-model.trim="formData.marital_status"
                            label="Marital Status"
                            type="text"
                            placeholder="Enter Marital Status"
                            class="w-full"
                            :class="getErrorClass('marital_status')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Dob Day</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrldob_day"
                            v-model.trim="formData.dob_day"
                            label="Dob Day"
                            type="text"
                            placeholder="Enter Dob Day"
                            class="w-full"
                            :class="getErrorClass('dob_day')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Dob Month</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrldob_month"
                            v-model.trim="formData.dob_month"
                            label="Dob Month"
                            type="text"
                            placeholder="Enter Dob Month"
                            class="w-full"
                            :class="getErrorClass('dob_month')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Dob Year</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrldob_year"
                            v-model.trim="formData.dob_year"
                            label="Dob Year"
                            type="text"
                            placeholder="Enter Dob Year"
                            class="w-full"
                            :class="getErrorClass('dob_year')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Email Address</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlemail_address"
                            v-model.trim="formData.email_address"
                            label="Email Address"
                            type="email"
                            placeholder="Enter Email Address"
                            class="w-full"
                            :class="getErrorClass('email_address')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Address Line1</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrladdress_line1"
                            v-model.trim="formData.address_line1"
                            label="Address Line1"
                            type="text"
                            placeholder="Enter Address Line1"
                            class="w-full"
                            :class="getErrorClass('address_line1')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Address Line2</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrladdress_line2"
                            v-model.trim="formData.address_line2"
                            label="Address Line2"
                            type="text"
                            placeholder="Enter Address Line2"
                            class="w-full"
                            :class="getErrorClass('address_line2')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Address Line3</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrladdress_line3"
                            v-model.trim="formData.address_line3"
                            label="Address Line3"
                            type="text"
                            placeholder="Enter Address Line3"
                            class="w-full"
                            :class="getErrorClass('address_line3')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Address Line4</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrladdress_line4"
                            v-model.trim="formData.address_line4"
                            label="Address Line4"
                            type="text"
                            placeholder="Enter Address Line4"
                            class="w-full"
                            :class="getErrorClass('address_line4')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Street Address</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlstreet_address"
                            v-model.trim="formData.street_address"
                            label="Street Address"
                            type="text"
                            placeholder="Enter Street Address"
                            class="w-full"
                            :class="getErrorClass('street_address')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Digital Address</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrldigital_address"
                            v-model.trim="formData.digital_address"
                            label="Digital Address"
                            type="text"
                            placeholder="Enter Digital Address"
                            class="w-full"
                            :class="getErrorClass('digital_address')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Same Address As Ph Address
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsame_address_as_ph_address"
                            v-model.trim="formData.same_address_as_ph_address"
                            label="Same Address As Ph Address"
                            type="text"
                            placeholder="Enter Same Address As Ph Address"
                            class="w-full"
                            :class="getErrorClass('same_address_as_ph_address')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Same Bio As Sponsor</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsame_bio_as_sponsor"
                            v-model.trim="formData.same_bio_as_sponsor"
                            label="Same Bio As Sponsor"
                            type="text"
                            placeholder="Enter Same Bio As Sponsor"
                            class="w-full"
                            :class="getErrorClass('same_bio_as_sponsor')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Ph Address Line1</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlph_address_line1"
                            v-model.trim="formData.ph_address_line1"
                            label="Ph Address Line1"
                            type="text"
                            placeholder="Enter Ph Address Line1"
                            class="w-full"
                            :class="getErrorClass('ph_address_line1')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Ph Address Line2</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlph_address_line2"
                            v-model.trim="formData.ph_address_line2"
                            label="Ph Address Line2"
                            type="text"
                            placeholder="Enter Ph Address Line2"
                            class="w-full"
                            :class="getErrorClass('ph_address_line2')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Ph Address Line3</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlph_address_line3"
                            v-model.trim="formData.ph_address_line3"
                            label="Ph Address Line3"
                            type="text"
                            placeholder="Enter Ph Address Line3"
                            class="w-full"
                            :class="getErrorClass('ph_address_line3')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Ph Address Line4</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlph_address_line4"
                            v-model.trim="formData.ph_address_line4"
                            label="Ph Address Line4"
                            type="text"
                            placeholder="Enter Ph Address Line4"
                            class="w-full"
                            :class="getErrorClass('ph_address_line4')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Sponsor Name</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsponsor_name"
                            v-model.trim="formData.sponsor_name"
                            label="Sponsor Name"
                            type="text"
                            placeholder="Enter Sponsor Name"
                            class="w-full"
                            :class="getErrorClass('sponsor_name')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Sponsor Address</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsponsor_address"
                            v-model.trim="formData.sponsor_address"
                            label="Sponsor Address"
                            type="text"
                            placeholder="Enter Sponsor Address"
                            class="w-full"
                            :class="getErrorClass('sponsor_address')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Sponsor Telephone</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsponsor_telephone"
                            v-model.trim="formData.sponsor_telephone"
                            label="Sponsor Telephone"
                            type="text"
                            placeholder="Enter Sponsor Telephone"
                            class="w-full"
                            :class="getErrorClass('sponsor_telephone')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Sponsor Email</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsponsor_email"
                            v-model.trim="formData.sponsor_email"
                            label="Sponsor Email"
                            type="email"
                            placeholder="Enter Sponsor Email"
                            class="w-full"
                            :class="getErrorClass('sponsor_email')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Name</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_name"
                            v-model.trim="formData.guardian_name"
                            label="Guardian Name"
                            type="text"
                            placeholder="Enter Guardian Name"
                            class="w-full"
                            :class="getErrorClass('guardian_name')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Email</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_email"
                            v-model.trim="formData.guardian_email"
                            label="Guardian Email"
                            type="email"
                            placeholder="Enter Guardian Email"
                            class="w-full"
                            :class="getErrorClass('guardian_email')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Address1</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_address1"
                            v-model.trim="formData.guardian_address1"
                            label="Guardian Address1"
                            type="text"
                            placeholder="Enter Guardian Address1"
                            class="w-full"
                            :class="getErrorClass('guardian_address1')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Address2</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_address2"
                            v-model.trim="formData.guardian_address2"
                            label="Guardian Address2"
                            type="text"
                            placeholder="Enter Guardian Address2"
                            class="w-full"
                            :class="getErrorClass('guardian_address2')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Address3</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_address3"
                            v-model.trim="formData.guardian_address3"
                            label="Guardian Address3"
                            type="text"
                            placeholder="Enter Guardian Address3"
                            class="w-full"
                            :class="getErrorClass('guardian_address3')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Occupation</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_occupation"
                            v-model.trim="formData.guardian_occupation"
                            label="Guardian Occupation"
                            type="text"
                            placeholder="Enter Guardian Occupation"
                            class="w-full"
                            :class="getErrorClass('guardian_occupation')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Guardian Telephone</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_telephone"
                            v-model.trim="formData.guardian_telephone"
                            label="Guardian Telephone"
                            type="text"
                            placeholder="Enter Guardian Telephone"
                            class="w-full"
                            :class="getErrorClass('guardian_telephone')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Passport Picture</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <div class="mb-3">
                            <Uploader
                              :class="getErrorClass('passport_picture')"
                              upload-path="fileuploader/upload/passport_picture"
                              v-model="formData.passport_picture"
                              :fileLimit="1"
                              :maxFileSize="3000000"
                              accept=".jpg,.png,.gif,.jpeg"
                              :multiple="false"
                              label="Choose files or drop files here"
                            />
                          </div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Is Athlete</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlis_athlete"
                            v-model.trim="formData.is_athlete"
                            label="Is Athlete"
                            type="text"
                            placeholder="Enter Is Athlete"
                            class="w-full"
                            :class="getErrorClass('is_athlete')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Last Competition</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="getErrorClass('last_competition')"
                            class="w-full"
                            ref="ctrllast_competition"
                            rows="5"
                            v-model="formData.last_competition"
                            placeholder="Enter Last Competition"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Sports Rep Institution
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsports_rep_institution"
                            v-model.trim="formData.sports_rep_institution"
                            label="Sports Rep Institution"
                            type="text"
                            placeholder="Enter Sports Rep Institution"
                            class="w-full"
                            :class="getErrorClass('sports_rep_institution')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Is Disable</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlis_disable"
                            v-model.trim="formData.is_disable"
                            label="Is Disable"
                            type="text"
                            placeholder="Enter Is Disable"
                            class="w-full"
                            :class="getErrorClass('is_disable')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Disability</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="getErrorClass('disability')"
                            class="w-full"
                            ref="ctrldisability"
                            rows="5"
                            v-model="formData.disability"
                            placeholder="Enter Disability"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Is Employed</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlis_employed"
                            v-model.trim="formData.is_employed"
                            label="Is Employed"
                            type="text"
                            placeholder="Enter Is Employed"
                            class="w-full"
                            :class="getErrorClass('is_employed')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Employment Nature</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlemployment_nature"
                            v-model.trim="formData.employment_nature"
                            label="Employment Nature"
                            type="text"
                            placeholder="Enter Employment Nature"
                            class="w-full"
                            :class="getErrorClass('employment_nature')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Employment Address</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlemployment_address"
                            v-model.trim="formData.employment_address"
                            label="Employment Address"
                            type="text"
                            placeholder="Enter Employment Address"
                            class="w-full"
                            :class="getErrorClass('employment_address')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Employment Nature Other
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlemployment_nature_other"
                            v-model.trim="formData.employment_nature_other"
                            label="Employment Nature Other"
                            type="text"
                            placeholder="Enter Employment Nature Other"
                            class="w-full"
                            :class="getErrorClass('employment_nature_other')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Guardian Occupation Other
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlguardian_occupation_other"
                            v-model.trim="formData.guardian_occupation_other"
                            label="Guardian Occupation Other"
                            type="text"
                            placeholder="Enter Guardian Occupation Other"
                            class="w-full"
                            :class="getErrorClass('guardian_occupation_other')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Disability Other</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrldisability_other"
                            v-model.trim="formData.disability_other"
                            label="Disability Other"
                            type="text"
                            placeholder="Enter Disability Other"
                            class="w-full"
                            :class="getErrorClass('disability_other')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Religious Denomination Other
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlreligious_denomination_other"
                            v-model.trim="formData.religious_denomination_other"
                            label="Religious Denomination Other"
                            type="text"
                            placeholder="Enter Religious Denomination Other"
                            class="w-full"
                            :class="
                              getErrorClass('religious_denomination_other')
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Scanned National ID Card
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="getErrorClass('scanned_national_id_card')"
                            class="w-full"
                            ref="ctrlscanned_national_id_card"
                            rows="5"
                            v-model="formData.scanned_national_id_card"
                            placeholder="Enter Scanned National ID Card"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">National ID Type</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlnational_id_type"
                            v-model.trim="formData.national_id_type"
                            label="National ID Type"
                            type="text"
                            placeholder="Enter National ID Type"
                            class="w-full"
                            :class="getErrorClass('national_id_type')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">National ID Number</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlnational_id_number"
                            v-model.trim="formData.national_id_number"
                            label="National ID Number"
                            type="text"
                            placeholder="Enter National ID Number"
                            class="w-full"
                            :class="getErrorClass('national_id_number')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Fathers Name</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfathers_name"
                            v-model.trim="formData.fathers_name"
                            label="Fathers Name"
                            type="text"
                            placeholder="Enter Fathers Name"
                            class="w-full"
                            :class="getErrorClass('fathers_name')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Fathers Telephone</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfathers_telephone"
                            v-model.trim="formData.fathers_telephone"
                            label="Fathers Telephone"
                            type="text"
                            placeholder="Enter Fathers Telephone"
                            class="w-full"
                            :class="getErrorClass('fathers_telephone')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Fathers Occupation</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfathers_occupation"
                            v-model.trim="formData.fathers_occupation"
                            label="Fathers Occupation"
                            type="text"
                            placeholder="Enter Fathers Occupation"
                            class="w-full"
                            :class="getErrorClass('fathers_occupation')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Fathers Occupation Other
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfathers_occupation_other"
                            v-model.trim="formData.fathers_occupation_other"
                            label="Fathers Occupation Other"
                            type="text"
                            placeholder="Enter Fathers Occupation Other"
                            class="w-full"
                            :class="getErrorClass('fathers_occupation_other')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Mothers Name</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmothers_name"
                            v-model.trim="formData.mothers_name"
                            label="Mothers Name"
                            type="text"
                            placeholder="Enter Mothers Name"
                            class="w-full"
                            :class="getErrorClass('mothers_name')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Mothers Telephone</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmothers_telephone"
                            v-model.trim="formData.mothers_telephone"
                            label="Mothers Telephone"
                            type="text"
                            placeholder="Enter Mothers Telephone"
                            class="w-full"
                            :class="getErrorClass('mothers_telephone')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Mothers Occupation</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmothers_occupation"
                            v-model.trim="formData.mothers_occupation"
                            label="Mothers Occupation"
                            type="text"
                            placeholder="Enter Mothers Occupation"
                            class="w-full"
                            :class="getErrorClass('mothers_occupation')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Mothers Occupation Other
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmothers_occupation_other"
                            v-model.trim="formData.mothers_occupation_other"
                            label="Mothers Occupation Other"
                            type="text"
                            placeholder="Enter Mothers Occupation Other"
                            class="w-full"
                            :class="getErrorClass('mothers_occupation_other')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Attended SHS</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlattended_shs"
                            v-model.trim="formData.attended_shs"
                            label="Attended SHS"
                            type="text"
                            placeholder="Enter Attended SHS"
                            class="w-full"
                            :class="getErrorClass('attended_shs')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Last SHS Attended</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrllast_shs_attended"
                            v-model.trim="formData.last_shs_attended"
                            label="Last SHS Attended"
                            type="text"
                            placeholder="Enter Last SHS Attended"
                            class="w-full"
                            :class="getErrorClass('last_shs_attended')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Index Number</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlindex_number"
                            v-model.trim="formData.index_number"
                            label="Index Number"
                            type="text"
                            placeholder="Enter Index Number"
                            class="w-full"
                            :class="getErrorClass('index_number')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS Course</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_course"
                            v-model.trim="formData.shs_course"
                            label="SHS Course"
                            type="text"
                            placeholder="Enter SHS Course"
                            class="w-full"
                            :class="getErrorClass('shs_course')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS Grade</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_grade"
                            v-model.trim="formData.shs_grade"
                            label="SHS Grade"
                            type="text"
                            placeholder="Enter SHS Grade"
                            class="w-full"
                            :class="getErrorClass('shs_grade')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Certificate Url</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="getErrorClass('certificate_url')"
                            class="w-full"
                            ref="ctrlcertificate_url"
                            rows="5"
                            v-model="formData.certificate_url"
                            placeholder="Enter Certificate Url"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Is Awaiting Results</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlis_awaiting_results"
                            v-model.trim="formData.is_awaiting_results"
                            label="Is Awaiting Results"
                            type="text"
                            placeholder="Enter Is Awaiting Results"
                            class="w-full"
                            :class="getErrorClass('is_awaiting_results')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS From Year</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_from_year"
                            v-model.trim="formData.shs_from_year"
                            label="SHS From Year"
                            type="text"
                            placeholder="Enter SHS From Year"
                            class="w-full"
                            :class="getErrorClass('shs_from_year')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS To Year</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_to_year"
                            v-model.trim="formData.shs_to_year"
                            label="SHS To Year"
                            type="text"
                            placeholder="Enter SHS To Year"
                            class="w-full"
                            :class="getErrorClass('shs_to_year')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS Qualification</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_qualification"
                            v-model.trim="formData.shs_qualification"
                            label="SHS Qualification"
                            type="text"
                            placeholder="Enter SHS Qualification"
                            class="w-full"
                            :class="getErrorClass('shs_qualification')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS Exams Results</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_exams_results"
                            v-model.trim="formData.shs_exams_results"
                            label="SHS Exams Results"
                            type="text"
                            placeholder="Enter SHS Exams Results"
                            class="w-full"
                            :class="getErrorClass('shs_exams_results')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Has Attended Tertiary</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlhas_attended_tertiary"
                            v-model.trim="formData.has_attended_tertiary"
                            label="Has Attended Tertiary"
                            type="text"
                            placeholder="Enter Has Attended Tertiary"
                            class="w-full"
                            :class="getErrorClass('has_attended_tertiary')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Last Tertiary Attended
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrllast_tertiary_attended"
                            v-model.trim="formData.last_tertiary_attended"
                            label="Last Tertiary Attended"
                            type="text"
                            placeholder="Enter Last Tertiary Attended"
                            class="w-full"
                            :class="getErrorClass('last_tertiary_attended')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary From Year</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_from_year"
                            v-model.trim="formData.tertiary_from_year"
                            label="Tertiary From Year"
                            type="text"
                            placeholder="Enter Tertiary From Year"
                            class="w-full"
                            :class="getErrorClass('tertiary_from_year')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary To Year</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_to_year"
                            v-model.trim="formData.tertiary_to_year"
                            label="Tertiary To Year"
                            type="text"
                            placeholder="Enter Tertiary To Year"
                            class="w-full"
                            :class="getErrorClass('tertiary_to_year')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary Programme</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_programme"
                            v-model.trim="formData.tertiary_programme"
                            label="Tertiary Programme"
                            type="text"
                            placeholder="Enter Tertiary Programme"
                            class="w-full"
                            :class="getErrorClass('tertiary_programme')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary Student ID</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_student_id"
                            v-model.trim="formData.tertiary_student_id"
                            label="Tertiary Student ID"
                            type="text"
                            placeholder="Enter Tertiary Student ID"
                            class="w-full"
                            :class="getErrorClass('tertiary_student_id')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Tertiary Reason For Leaving
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_reason_for_leaving"
                            v-model.trim="formData.tertiary_reason_for_leaving"
                            label="Tertiary Reason For Leaving"
                            type="text"
                            placeholder="Enter Tertiary Reason For Leaving"
                            class="w-full"
                            :class="
                              getErrorClass('tertiary_reason_for_leaving')
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Tertiary Degree Awarded
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_degree_awarded"
                            v-model.trim="formData.tertiary_degree_awarded"
                            label="Tertiary Degree Awarded"
                            type="text"
                            placeholder="Enter Tertiary Degree Awarded"
                            class="w-full"
                            :class="getErrorClass('tertiary_degree_awarded')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary Degree Class</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_degree_class"
                            v-model.trim="formData.tertiary_degree_class"
                            label="Tertiary Degree Class"
                            type="text"
                            placeholder="Enter Tertiary Degree Class"
                            class="w-full"
                            :class="getErrorClass('tertiary_degree_class')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Exams Sittings</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlexams_sittings"
                            v-model.trim="formData.exams_sittings"
                            label="Exams Sittings"
                            type="text"
                            placeholder="Enter Exams Sittings"
                            class="w-full"
                            :class="getErrorClass('exams_sittings')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Last SHS Other</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrllast_shs_other"
                            v-model.trim="formData.last_shs_other"
                            label="Last SHS Other"
                            type="text"
                            placeholder="Enter Last SHS Other"
                            class="w-full"
                            :class="getErrorClass('last_shs_other')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Last SHS Outside</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrllast_shs_outside"
                            v-model.trim="formData.last_shs_outside"
                            label="Last SHS Outside"
                            type="text"
                            placeholder="Enter Last SHS Outside"
                            class="w-full"
                            :class="getErrorClass('last_shs_outside')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Institution Additional Info
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlinstitution_additional_info"
                            v-model.trim="formData.institution_additional_info"
                            label="Institution Additional Info"
                            type="text"
                            placeholder="Enter Institution Additional Info"
                            class="w-full"
                            :class="
                              getErrorClass('institution_additional_info')
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Account Name</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlaccount_name"
                            v-model.trim="formData.account_name"
                            label="Account Name"
                            type="text"
                            placeholder="Enter Account Name"
                            class="w-full"
                            :class="getErrorClass('account_name')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Account Username</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlaccount_username"
                            v-model.trim="formData.account_username"
                            label="Account Username"
                            type="text"
                            placeholder="Enter Account Username"
                            class="w-full"
                            :class="getErrorClass('account_username')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Account Email</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlaccount_email"
                            v-model.trim="formData.account_email"
                            label="Account Email"
                            type="email"
                            placeholder="Enter Account Email"
                            class="w-full"
                            :class="getErrorClass('account_email')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Account Password</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Password
                            ref="ctrlaccount_password"
                            v-model="formData.account_password"
                            label="Account Password"
                            placeholder="Enter Account Password"
                            class="w-full"
                            inputClass="w-full"
                            toggleMask
                            :feedback="true"
                            :class="getErrorClass('account_password')"
                          />
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Confirm Password</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Password
                            class="w-full"
                            :class="getErrorClass('account_password')"
                            inputClass="w-full"
                            :feedback="false"
                            toggleMask
                            ref="ctrlconfirmaccount_password"
                            v-model="formData.confirm_password"
                            label="Confirm Password"
                            placeholder="Confirm Password"
                          />
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Account Photo</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <div class="mb-3">
                            <Uploader
                              :class="getErrorClass('account_photo')"
                              upload-path="fileuploader/upload/account_photo"
                              v-model="formData.account_photo"
                              :fileLimit="1"
                              :maxFileSize="3000000"
                              accept=".jpg,.png,.gif,.jpeg"
                              :multiple="false"
                              label="Choose files or drop files here"
                            />
                          </div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Allow Two Factor Auth</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlallow_two_factor_auth"
                            v-model.trim="formData.allow_two_factor_auth"
                            label="Allow Two Factor Auth"
                            type="text"
                            placeholder="Enter Allow Two Factor Auth"
                            class="w-full"
                            :class="getErrorClass('allow_two_factor_auth')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Allow Email Alert</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlallow_email_alert"
                            v-model.trim="formData.allow_email_alert"
                            label="Allow Email Alert"
                            type="email"
                            placeholder="Enter Allow Email Alert"
                            class="w-full"
                            :class="getErrorClass('allow_email_alert')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Allow Sms Alert</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlallow_sms_alert"
                            v-model.trim="formData.allow_sms_alert"
                            label="Allow Sms Alert"
                            type="text"
                            placeholder="Enter Allow Sms Alert"
                            class="w-full"
                            :class="getErrorClass('allow_sms_alert')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Account Status</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlaccount_status"
                            v-model.trim="formData.account_status"
                            label="Account Status"
                            type="text"
                            placeholder="Enter Account Status"
                            class="w-full"
                            :class="getErrorClass('account_status')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Email Verified At</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Calendar
                            :showButtonBar="true"
                            :showTime="true"
                            dateFormat="yy-mm-dd"
                            hourFormat="24"
                            v-model="formData.email_verified_at"
                            :showIcon="true"
                            class="w-full"
                            :class="getErrorClass('email_verified_at')"
                            mask="yy-MM-DD HH:mm"
                          />
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Fathers Email</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfathers_email"
                            v-model.trim="formData.fathers_email"
                            label="Fathers Email"
                            type="email"
                            placeholder="Enter Fathers Email"
                            class="w-full"
                            :class="getErrorClass('fathers_email')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Mothers Email</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmothers_email"
                            v-model.trim="formData.mothers_email"
                            label="Mothers Email"
                            type="email"
                            placeholder="Enter Mothers Email"
                            class="w-full"
                            :class="getErrorClass('mothers_email')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Fathers Living Status</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfathers_living_status"
                            v-model.trim="formData.fathers_living_status"
                            label="Fathers Living Status"
                            type="text"
                            placeholder="Enter Fathers Living Status"
                            class="w-full"
                            :class="getErrorClass('fathers_living_status')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Mothers Living Status</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlmothers_living_status"
                            v-model.trim="formData.mothers_living_status"
                            label="Mothers Living Status"
                            type="text"
                            placeholder="Enter Mothers Living Status"
                            class="w-full"
                            :class="getErrorClass('mothers_living_status')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Entry Level</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlentry_level"
                            v-model.trim="formData.entry_level"
                            label="Entry Level"
                            type="text"
                            placeholder="Enter Entry Level"
                            class="w-full"
                            :class="getErrorClass('entry_level')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Entry Level Scenario</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlentry_level_scenario"
                            v-model.trim="formData.entry_level_scenario"
                            label="Entry Level Scenario"
                            type="text"
                            placeholder="Enter Entry Level Scenario"
                            class="w-full"
                            :class="getErrorClass('entry_level_scenario')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Otp Code</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlotp_code"
                            v-model.trim="formData.otp_code"
                            label="Otp Code"
                            type="text"
                            placeholder="Enter Otp Code"
                            class="w-full"
                            :class="getErrorClass('otp_code')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Otp Date</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Calendar
                            :showButtonBar="true"
                            :showTime="true"
                            dateFormat="yy-mm-dd"
                            hourFormat="24"
                            v-model="formData.otp_date"
                            :showIcon="true"
                            class="w-full"
                            :class="getErrorClass('otp_date')"
                            mask="yy-MM-DD HH:mm"
                          />
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">First Institution ID</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_id"
                            v-model.trim="formData.first_institution_id"
                            label="First Institution ID"
                            type="number"
                            placeholder="Enter First Institution ID"
                            step="any"
                            class="w-full"
                            :class="getErrorClass('first_institution_id')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Second Institution ID</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_id"
                            v-model.trim="formData.second_institution_id"
                            label="Second Institution ID"
                            type="number"
                            placeholder="Enter Second Institution ID"
                            step="any"
                            class="w-full"
                            :class="getErrorClass('second_institution_id')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Third Institution ID</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_id"
                            v-model.trim="formData.third_institution_id"
                            label="Third Institution ID"
                            type="number"
                            placeholder="Enter Third Institution ID"
                            step="any"
                            class="w-full"
                            :class="getErrorClass('third_institution_id')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution First Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_first_programme_id"
                            v-model.trim="
                              formData.first_institution_first_programme_id
                            "
                            label="First Institution First Programme ID"
                            type="number"
                            placeholder="Enter First Institution First Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_first_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Second Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_second_programme_id"
                            v-model.trim="
                              formData.first_institution_second_programme_id
                            "
                            label="First Institution Second Programme ID"
                            type="number"
                            placeholder="Enter First Institution Second Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_second_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Third Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_third_programme_id"
                            v-model.trim="
                              formData.first_institution_third_programme_id
                            "
                            label="First Institution Third Programme ID"
                            type="number"
                            placeholder="Enter First Institution Third Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_third_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution First Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_first_programme_session"
                            v-model.trim="
                              formData.first_institution_first_programme_session
                            "
                            label="First Institution First Programme Session"
                            type="text"
                            placeholder="Enter First Institution First Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_first_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Second Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_second_programme_session"
                            v-model.trim="
                              formData.first_institution_second_programme_session
                            "
                            label="First Institution Second Programme Session"
                            type="text"
                            placeholder="Enter First Institution Second Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_second_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Third Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_third_programme_session"
                            v-model.trim="
                              formData.first_institution_third_programme_session
                            "
                            label="First Institution Third Programme Session"
                            type="text"
                            placeholder="Enter First Institution Third Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_third_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution First Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'first_institution_first_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlfirst_institution_first_programme_options"
                            rows="5"
                            v-model="
                              formData.first_institution_first_programme_options
                            "
                            placeholder="Enter First Institution First Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Second Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'first_institution_second_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlfirst_institution_second_programme_options"
                            rows="5"
                            v-model="
                              formData.first_institution_second_programme_options
                            "
                            placeholder="Enter First Institution Second Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Third Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'first_institution_third_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlfirst_institution_third_programme_options"
                            rows="5"
                            v-model="
                              formData.first_institution_third_programme_options
                            "
                            placeholder="Enter First Institution Third Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution First Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_first_programme_id"
                            v-model.trim="
                              formData.second_institution_first_programme_id
                            "
                            label="Second Institution First Programme ID"
                            type="number"
                            placeholder="Enter Second Institution First Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_first_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Second Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_second_programme_id"
                            v-model.trim="
                              formData.second_institution_second_programme_id
                            "
                            label="Second Institution Second Programme ID"
                            type="number"
                            placeholder="Enter Second Institution Second Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_second_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Third Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_third_programme_id"
                            v-model.trim="
                              formData.second_institution_third_programme_id
                            "
                            label="Second Institution Third Programme ID"
                            type="number"
                            placeholder="Enter Second Institution Third Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_third_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution First Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_first_programme_session"
                            v-model.trim="
                              formData.second_institution_first_programme_session
                            "
                            label="Second Institution First Programme Session"
                            type="text"
                            placeholder="Enter Second Institution First Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_first_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Second Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_second_programme_session"
                            v-model.trim="
                              formData.second_institution_second_programme_session
                            "
                            label="Second Institution Second Programme Session"
                            type="text"
                            placeholder="Enter Second Institution Second Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_second_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Third Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_third_programme_session"
                            v-model.trim="
                              formData.second_institution_third_programme_session
                            "
                            label="Second Institution Third Programme Session"
                            type="text"
                            placeholder="Enter Second Institution Third Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_third_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution First Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'second_institution_first_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlsecond_institution_first_programme_options"
                            rows="5"
                            v-model="
                              formData.second_institution_first_programme_options
                            "
                            placeholder="Enter Second Institution First Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Second Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'second_institution_second_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlsecond_institution_second_programme_options"
                            rows="5"
                            v-model="
                              formData.second_institution_second_programme_options
                            "
                            placeholder="Enter Second Institution Second Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Third Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'second_institution_third_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlsecond_institution_third_programme_options"
                            rows="5"
                            v-model="
                              formData.second_institution_third_programme_options
                            "
                            placeholder="Enter Second Institution Third Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution First Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_first_programme_id"
                            v-model.trim="
                              formData.third_institution_first_programme_id
                            "
                            label="Third Institution First Programme ID"
                            type="number"
                            placeholder="Enter Third Institution First Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_first_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Second Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_second_programme_id"
                            v-model.trim="
                              formData.third_institution_second_programme_id
                            "
                            label="Third Institution Second Programme ID"
                            type="number"
                            placeholder="Enter Third Institution Second Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_second_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Third Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_third_programme_id"
                            v-model.trim="
                              formData.third_institution_third_programme_id
                            "
                            label="Third Institution Third Programme ID"
                            type="number"
                            placeholder="Enter Third Institution Third Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_third_programme_id'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution First Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_first_programme_session"
                            v-model.trim="
                              formData.third_institution_first_programme_session
                            "
                            label="Third Institution First Programme Session"
                            type="text"
                            placeholder="Enter Third Institution First Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_first_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Second Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_second_programme_session"
                            v-model.trim="
                              formData.third_institution_second_programme_session
                            "
                            label="Third Institution Second Programme Session"
                            type="text"
                            placeholder="Enter Third Institution Second Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_second_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Third Programme Session
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_third_programme_session"
                            v-model.trim="
                              formData.third_institution_third_programme_session
                            "
                            label="Third Institution Third Programme Session"
                            type="text"
                            placeholder="Enter Third Institution Third Programme Session"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_third_programme_session'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution First Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'third_institution_first_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlthird_institution_first_programme_options"
                            rows="5"
                            v-model="
                              formData.third_institution_first_programme_options
                            "
                            placeholder="Enter Third Institution First Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Second Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'third_institution_second_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlthird_institution_second_programme_options"
                            rows="5"
                            v-model="
                              formData.third_institution_second_programme_options
                            "
                            placeholder="Enter Third Institution Second Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Third Programme Options
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <Textarea
                            :class="
                              getErrorClass(
                                'third_institution_third_programme_options'
                              )
                            "
                            class="w-full"
                            ref="ctrlthird_institution_third_programme_options"
                            rows="5"
                            v-model="
                              formData.third_institution_third_programme_options
                            "
                            placeholder="Enter Third Institution Third Programme Options"
                            type="textarea"
                          >
                          </Textarea>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Applicant Accepted Programme ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlapplicant_accepted_programme_id"
                            v-model.trim="
                              formData.applicant_accepted_programme_id
                            "
                            label="Applicant Accepted Programme ID"
                            type="number"
                            placeholder="Enter Applicant Accepted Programme ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass('applicant_accepted_programme_id')
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution First Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_first_programme_admission_status"
                            v-model.trim="
                              formData.first_institution_first_programme_admission_status
                            "
                            label="First Institution First Programme Admission Status"
                            type="text"
                            placeholder="Enter First Institution First Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_first_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Second Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_second_programme_admission_status"
                            v-model.trim="
                              formData.first_institution_second_programme_admission_status
                            "
                            label="First Institution Second Programme Admission Status"
                            type="text"
                            placeholder="Enter First Institution Second Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_second_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Third Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_third_programme_admission_status"
                            v-model.trim="
                              formData.first_institution_third_programme_admission_status
                            "
                            label="First Institution Third Programme Admission Status"
                            type="text"
                            placeholder="Enter First Institution Third Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_third_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution First Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_first_programme_admission_status"
                            v-model.trim="
                              formData.second_institution_first_programme_admission_status
                            "
                            label="Second Institution First Programme Admission Status"
                            type="text"
                            placeholder="Enter Second Institution First Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_first_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Second Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_second_programme_admission_status"
                            v-model.trim="
                              formData.second_institution_second_programme_admission_status
                            "
                            label="Second Institution Second Programme Admission Status"
                            type="text"
                            placeholder="Enter Second Institution Second Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_second_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Third Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_third_programme_admission_status"
                            v-model.trim="
                              formData.second_institution_third_programme_admission_status
                            "
                            label="Second Institution Third Programme Admission Status"
                            type="text"
                            placeholder="Enter Second Institution Third Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_third_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution First Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_first_programme_admission_status"
                            v-model.trim="
                              formData.third_institution_first_programme_admission_status
                            "
                            label="Third Institution First Programme Admission Status"
                            type="text"
                            placeholder="Enter Third Institution First Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_first_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Second Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_second_programme_admission_status"
                            v-model.trim="
                              formData.third_institution_second_programme_admission_status
                            "
                            label="Third Institution Second Programme Admission Status"
                            type="text"
                            placeholder="Enter Third Institution Second Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_second_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Third Programme Admission Status
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_third_programme_admission_status"
                            v-model.trim="
                              formData.third_institution_third_programme_admission_status
                            "
                            label="Third Institution Third Programme Admission Status"
                            type="text"
                            placeholder="Enter Third Institution Third Programme Admission Status"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_third_programme_admission_status'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Payment Status</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlpayment_status"
                            v-model.trim="formData.payment_status"
                            label="Payment Status"
                            type="text"
                            placeholder="Enter Payment Status"
                            class="w-full"
                            :class="getErrorClass('payment_status')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Application Status</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlapplication_status"
                            v-model.trim="formData.application_status"
                            label="Application Status"
                            type="text"
                            placeholder="Enter Application Status"
                            class="w-full"
                            :class="getErrorClass('application_status')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Applicant Accepted Institution ID
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlapplicant_accepted_institution_id"
                            v-model.trim="
                              formData.applicant_accepted_institution_id
                            "
                            label="Applicant Accepted Institution ID"
                            type="number"
                            placeholder="Enter Applicant Accepted Institution ID"
                            step="any"
                            class="w-full"
                            :class="
                              getErrorClass('applicant_accepted_institution_id')
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Applicant In School</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlapplicant_in_school"
                            v-model.trim="formData.applicant_in_school"
                            label="Applicant In School"
                            type="text"
                            placeholder="Enter Applicant In School"
                            class="w-full"
                            :class="getErrorClass('applicant_in_school')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">SHS Country</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlshs_country"
                            v-model.trim="formData.shs_country"
                            label="SHS Country"
                            type="text"
                            placeholder="Enter SHS Country"
                            class="w-full"
                            :class="getErrorClass('shs_country')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution First Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_first_programme_campus"
                            v-model.trim="
                              formData.first_institution_first_programme_campus
                            "
                            label="First Institution First Programme Campus"
                            type="text"
                            placeholder="Enter First Institution First Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_first_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Second Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_second_programme_campus"
                            v-model.trim="
                              formData.first_institution_second_programme_campus
                            "
                            label="First Institution Second Programme Campus"
                            type="text"
                            placeholder="Enter First Institution Second Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_second_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          First Institution Third Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlfirst_institution_third_programme_campus"
                            v-model.trim="
                              formData.first_institution_third_programme_campus
                            "
                            label="First Institution Third Programme Campus"
                            type="text"
                            placeholder="Enter First Institution Third Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'first_institution_third_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution First Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_first_programme_campus"
                            v-model.trim="
                              formData.second_institution_first_programme_campus
                            "
                            label="Second Institution First Programme Campus"
                            type="text"
                            placeholder="Enter Second Institution First Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_first_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Second Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_second_programme_campus"
                            v-model.trim="
                              formData.second_institution_second_programme_campus
                            "
                            label="Second Institution Second Programme Campus"
                            type="text"
                            placeholder="Enter Second Institution Second Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_second_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Second Institution Third Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlsecond_institution_third_programme_campus"
                            v-model.trim="
                              formData.second_institution_third_programme_campus
                            "
                            label="Second Institution Third Programme Campus"
                            type="text"
                            placeholder="Enter Second Institution Third Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'second_institution_third_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution First Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_first_programme_campus"
                            v-model.trim="
                              formData.third_institution_first_programme_campus
                            "
                            label="Third Institution First Programme Campus"
                            type="text"
                            placeholder="Enter Third Institution First Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_first_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Second Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_second_programme_campus"
                            v-model.trim="
                              formData.third_institution_second_programme_campus
                            "
                            label="Third Institution Second Programme Campus"
                            type="text"
                            placeholder="Enter Third Institution Second Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_second_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">
                          Third Institution Third Programme Campus
                        </div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrlthird_institution_third_programme_campus"
                            v-model.trim="
                              formData.third_institution_third_programme_campus
                            "
                            label="Third Institution Third Programme Campus"
                            type="text"
                            placeholder="Enter Third Institution Third Programme Campus"
                            class="w-full"
                            :class="
                              getErrorClass(
                                'third_institution_third_programme_campus'
                              )
                            "
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary Country</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_country"
                            v-model.trim="formData.tertiary_country"
                            label="Tertiary Country"
                            type="text"
                            placeholder="Enter Tertiary Country"
                            class="w-full"
                            :class="getErrorClass('tertiary_country')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Tertiary Name Outside</div>
                        <div class="col-12 md:col-9">
                          <!-- <div class="field mb-0"> -->
                          <InputText
                            ref="ctrltertiary_name_outside"
                            v-model.trim="formData.tertiary_name_outside"
                            label="Tertiary Name Outside"
                            type="text"
                            placeholder="Enter Tertiary Name Outside"
                            class="w-full"
                            :class="getErrorClass('tertiary_name_outside')"
                          >
                          </InputText>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showSubmitButton" class="text-center my-3">
                    <Button
                      class="p-button-primary"
                      type="submit"
                      label="Submit"
                      icon="pi pi-send"
                      :loading="saving"
                    />
                  </div>
                </form>
                <slot :submit="submit" :saving="saving"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { AddPageMixin } from "../../mixins/addpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "addApplicantsPage",
  components: {},
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "applicants",
    },
    routeName: {
      type: String,
      default: "applicantsadd",
    },
    apiPath: {
      type: String,
      default: "applicants/add",
    },
  },
  data() {
    return {
      formData: {
        application_ref: "",
        is_fee_paying: "",
        pass_to_affiliate: "",
        title: "",
        firstname: "",
        lastname: "",
        othernames: "",
        hometown: "",
        hometown_region: "",
        country: "",
        dial_code: "",
        primary_telephone: "",
        gender: "",
        religious_denomination: "",
        marital_status: "",
        dob_day: "",
        dob_month: "",
        dob_year: "",
        email_address: "",
        address_line1: "",
        address_line2: "",
        address_line3: "",
        address_line4: "",
        street_address: "",
        digital_address: "",
        same_address_as_ph_address: "",
        same_bio_as_sponsor: "",
        ph_address_line1: "",
        ph_address_line2: "",
        ph_address_line3: "",
        ph_address_line4: "",
        sponsor_name: "",
        sponsor_address: "",
        sponsor_telephone: "",
        sponsor_email: "",
        guardian_name: "",
        guardian_email: "",
        guardian_address1: "",
        guardian_address2: "",
        guardian_address3: "",
        guardian_occupation: "",
        guardian_telephone: "",
        passport_picture: "",
        is_athlete: "",
        last_competition: "",
        sports_rep_institution: "",
        is_disable: "",
        disability: "",
        is_employed: "",
        employment_nature: "",
        employment_address: "",
        employment_nature_other: "",
        guardian_occupation_other: "",
        disability_other: "",
        religious_denomination_other: "",
        scanned_national_id_card: "",
        national_id_type: "",
        national_id_number: "",
        fathers_name: "",
        fathers_telephone: "",
        fathers_occupation: "",
        fathers_occupation_other: "",
        mothers_name: "",
        mothers_telephone: "",
        mothers_occupation: "",
        mothers_occupation_other: "",
        attended_shs: "",
        last_shs_attended: "",
        index_number: "",
        shs_course: "",
        shs_grade: "",
        certificate_url: "",
        is_awaiting_results: "",
        shs_from_year: "",
        shs_to_year: "",
        shs_qualification: "",
        shs_exams_results: "",
        has_attended_tertiary: "",
        last_tertiary_attended: "",
        tertiary_from_year: "",
        tertiary_to_year: "",
        tertiary_programme: "",
        tertiary_student_id: "",
        tertiary_reason_for_leaving: "",
        tertiary_degree_awarded: "",
        tertiary_degree_class: "",
        exams_sittings: "",
        last_shs_other: "",
        last_shs_outside: "",
        institution_additional_info: "",
        account_name: "",
        account_username: "",
        account_email: "",
        account_password: "",
        confirm_password: "",
        account_photo: "",
        allow_two_factor_auth: "",
        allow_email_alert: "",
        allow_sms_alert: "",
        account_status: "",
        email_verified_at: "",
        fathers_email: "",
        mothers_email: "",
        fathers_living_status: "",
        mothers_living_status: "",
        entry_level: "",
        entry_level_scenario: "",
        otp_code: "",
        otp_date: "",
        first_institution_id: "",
        second_institution_id: "",
        third_institution_id: "",
        first_institution_first_programme_id: "",
        first_institution_second_programme_id: "",
        first_institution_third_programme_id: "",
        first_institution_first_programme_session: "",
        first_institution_second_programme_session: "",
        first_institution_third_programme_session: "",
        first_institution_first_programme_options: "",
        first_institution_second_programme_options: "",
        first_institution_third_programme_options: "",
        second_institution_first_programme_id: "",
        second_institution_second_programme_id: "",
        second_institution_third_programme_id: "",
        second_institution_first_programme_session: "",
        second_institution_second_programme_session: "",
        second_institution_third_programme_session: "",
        second_institution_first_programme_options: "",
        second_institution_second_programme_options: "",
        second_institution_third_programme_options: "",
        third_institution_first_programme_id: "",
        third_institution_second_programme_id: "",
        third_institution_third_programme_id: "",
        third_institution_first_programme_session: "",
        third_institution_second_programme_session: "",
        third_institution_third_programme_session: "",
        third_institution_first_programme_options: "",
        third_institution_second_programme_options: "",
        third_institution_third_programme_options: "",
        applicant_accepted_programme_id: "",
        first_institution_first_programme_admission_status: "",
        first_institution_second_programme_admission_status: "",
        first_institution_third_programme_admission_status: "",
        second_institution_first_programme_admission_status: "",
        second_institution_second_programme_admission_status: "",
        second_institution_third_programme_admission_status: "",
        third_institution_first_programme_admission_status: "",
        third_institution_second_programme_admission_status: "",
        third_institution_third_programme_admission_status: "",
        payment_status: "",
        application_status: "",
        applicant_accepted_institution_id: "",
        applicant_in_school: "",
        shs_country: "",
        first_institution_first_programme_campus: "",
        first_institution_second_programme_campus: "",
        first_institution_third_programme_campus: "",
        second_institution_first_programme_campus: "",
        second_institution_second_programme_campus: "",
        second_institution_third_programme_campus: "",
        third_institution_first_programme_campus: "",
        third_institution_second_programme_campus: "",
        third_institution_third_programme_campus: "",
        tertiary_country: "",
        tertiary_name_outside: "",
      },
      email_verified_atPicker: false,
      otp_datePicker: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Add New Applicants";
      },
    },
  },
  validations() {
    let formData = {
      application_ref: {},
      is_fee_paying: {},
      pass_to_affiliate: {},
      title: {},
      firstname: {},
      lastname: {},
      othernames: {},
      hometown: {},
      hometown_region: {},
      country: {},
      dial_code: {},
      primary_telephone: {},
      gender: {},
      religious_denomination: {},
      marital_status: {},
      dob_day: {},
      dob_month: {},
      dob_year: {},
      email_address: { email },
      address_line1: {},
      address_line2: {},
      address_line3: {},
      address_line4: {},
      street_address: {},
      digital_address: {},
      same_address_as_ph_address: {},
      same_bio_as_sponsor: {},
      ph_address_line1: {},
      ph_address_line2: {},
      ph_address_line3: {},
      ph_address_line4: {},
      sponsor_name: {},
      sponsor_address: {},
      sponsor_telephone: {},
      sponsor_email: { email },
      guardian_name: {},
      guardian_email: { email },
      guardian_address1: {},
      guardian_address2: {},
      guardian_address3: {},
      guardian_occupation: {},
      guardian_telephone: {},
      passport_picture: {},
      is_athlete: {},
      last_competition: {},
      sports_rep_institution: {},
      is_disable: {},
      disability: {},
      is_employed: {},
      employment_nature: {},
      employment_address: {},
      employment_nature_other: {},
      guardian_occupation_other: {},
      disability_other: {},
      religious_denomination_other: {},
      scanned_national_id_card: {},
      national_id_type: {},
      national_id_number: {},
      fathers_name: {},
      fathers_telephone: {},
      fathers_occupation: {},
      fathers_occupation_other: {},
      mothers_name: {},
      mothers_telephone: {},
      mothers_occupation: {},
      mothers_occupation_other: {},
      attended_shs: {},
      last_shs_attended: {},
      index_number: {},
      shs_course: {},
      shs_grade: {},
      certificate_url: {},
      is_awaiting_results: {},
      shs_from_year: {},
      shs_to_year: {},
      shs_qualification: {},
      shs_exams_results: {},
      has_attended_tertiary: {},
      last_tertiary_attended: {},
      tertiary_from_year: {},
      tertiary_to_year: {},
      tertiary_programme: {},
      tertiary_student_id: {},
      tertiary_reason_for_leaving: {},
      tertiary_degree_awarded: {},
      tertiary_degree_class: {},
      exams_sittings: {},
      last_shs_other: {},
      last_shs_outside: {},
      institution_additional_info: {},
      account_name: {},
      account_username: {},
      account_email: { email },
      account_password: {},
      account_photo: {},
      allow_two_factor_auth: {},
      allow_email_alert: { email },
      allow_sms_alert: {},
      account_status: {},
      email_verified_at: {},
      fathers_email: { email },
      mothers_email: { email },
      fathers_living_status: {},
      mothers_living_status: {},
      entry_level: {},
      entry_level_scenario: {},
      otp_code: {},
      otp_date: {},
      first_institution_id: {},
      second_institution_id: {},
      third_institution_id: {},
      first_institution_first_programme_id: {},
      first_institution_second_programme_id: {},
      first_institution_third_programme_id: {},
      first_institution_first_programme_session: {},
      first_institution_second_programme_session: {},
      first_institution_third_programme_session: {},
      first_institution_first_programme_options: {},
      first_institution_second_programme_options: {},
      first_institution_third_programme_options: {},
      second_institution_first_programme_id: {},
      second_institution_second_programme_id: {},
      second_institution_third_programme_id: {},
      second_institution_first_programme_session: {},
      second_institution_second_programme_session: {},
      second_institution_third_programme_session: {},
      second_institution_first_programme_options: {},
      second_institution_second_programme_options: {},
      second_institution_third_programme_options: {},
      third_institution_first_programme_id: {},
      third_institution_second_programme_id: {},
      third_institution_third_programme_id: {},
      third_institution_first_programme_session: {},
      third_institution_second_programme_session: {},
      third_institution_third_programme_session: {},
      third_institution_first_programme_options: {},
      third_institution_second_programme_options: {},
      third_institution_third_programme_options: {},
      applicant_accepted_programme_id: {},
      first_institution_first_programme_admission_status: {},
      first_institution_second_programme_admission_status: {},
      first_institution_third_programme_admission_status: {},
      second_institution_first_programme_admission_status: {},
      second_institution_second_programme_admission_status: {},
      second_institution_third_programme_admission_status: {},
      third_institution_first_programme_admission_status: {},
      third_institution_second_programme_admission_status: {},
      third_institution_third_programme_admission_status: {},
      payment_status: {},
      application_status: {},
      applicant_accepted_institution_id: {},
      applicant_in_school: {},
      shs_country: {},
      first_institution_first_programme_campus: {},
      first_institution_second_programme_campus: {},
      first_institution_third_programme_campus: {},
      second_institution_first_programme_campus: {},
      second_institution_second_programme_campus: {},
      second_institution_third_programme_campus: {},
      third_institution_first_programme_campus: {},
      third_institution_second_programme_campus: {},
      third_institution_third_programme_campus: {},
      tertiary_country: {},
      tertiary_name_outside: {},
    };
    return { formData };
  },
  methods: {
    ...mapActions("applicants", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Form is invalid", "", "error");
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.record = response.data ?? {};
          this.id = this.record["applicant_id"] ?? null;
          this.saving = false;
          this.resetForm();
          this.submitted = false;
          this.closeDialogs(); // close page dialog that if opened
          this.flashMsg(this.msgAfterSave);
          this.$emit("submitted", this.record);
          if (this.redirect) this.navigateTo(`/applicants`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    resetForm() {
      this.formData = {
        application_ref: "",
        is_fee_paying: "",
        pass_to_affiliate: "",
        title: "",
        firstname: "",
        lastname: "",
        othernames: "",
        hometown: "",
        hometown_region: "",
        country: "",
        dial_code: "",
        primary_telephone: "",
        gender: "",
        religious_denomination: "",
        marital_status: "",
        dob_day: "",
        dob_month: "",
        dob_year: "",
        email_address: "",
        address_line1: "",
        address_line2: "",
        address_line3: "",
        address_line4: "",
        street_address: "",
        digital_address: "",
        same_address_as_ph_address: "",
        same_bio_as_sponsor: "",
        ph_address_line1: "",
        ph_address_line2: "",
        ph_address_line3: "",
        ph_address_line4: "",
        sponsor_name: "",
        sponsor_address: "",
        sponsor_telephone: "",
        sponsor_email: "",
        guardian_name: "",
        guardian_email: "",
        guardian_address1: "",
        guardian_address2: "",
        guardian_address3: "",
        guardian_occupation: "",
        guardian_telephone: "",
        passport_picture: "",
        is_athlete: "",
        last_competition: "",
        sports_rep_institution: "",
        is_disable: "",
        disability: "",
        is_employed: "",
        employment_nature: "",
        employment_address: "",
        employment_nature_other: "",
        guardian_occupation_other: "",
        disability_other: "",
        religious_denomination_other: "",
        scanned_national_id_card: "",
        national_id_type: "",
        national_id_number: "",
        fathers_name: "",
        fathers_telephone: "",
        fathers_occupation: "",
        fathers_occupation_other: "",
        mothers_name: "",
        mothers_telephone: "",
        mothers_occupation: "",
        mothers_occupation_other: "",
        attended_shs: "",
        last_shs_attended: "",
        index_number: "",
        shs_course: "",
        shs_grade: "",
        certificate_url: "",
        is_awaiting_results: "",
        shs_from_year: "",
        shs_to_year: "",
        shs_qualification: "",
        shs_exams_results: "",
        has_attended_tertiary: "",
        last_tertiary_attended: "",
        tertiary_from_year: "",
        tertiary_to_year: "",
        tertiary_programme: "",
        tertiary_student_id: "",
        tertiary_reason_for_leaving: "",
        tertiary_degree_awarded: "",
        tertiary_degree_class: "",
        exams_sittings: "",
        last_shs_other: "",
        last_shs_outside: "",
        institution_additional_info: "",
        account_name: "",
        account_username: "",
        account_email: "",
        account_password: "",
        confirm_password: "",
        account_photo: "",
        allow_two_factor_auth: "",
        allow_email_alert: "",
        allow_sms_alert: "",
        account_status: "",
        email_verified_at: "",
        fathers_email: "",
        mothers_email: "",
        fathers_living_status: "",
        mothers_living_status: "",
        entry_level: "",
        entry_level_scenario: "",
        otp_code: "",
        otp_date: "",
        first_institution_id: "",
        second_institution_id: "",
        third_institution_id: "",
        first_institution_first_programme_id: "",
        first_institution_second_programme_id: "",
        first_institution_third_programme_id: "",
        first_institution_first_programme_session: "",
        first_institution_second_programme_session: "",
        first_institution_third_programme_session: "",
        first_institution_first_programme_options: "",
        first_institution_second_programme_options: "",
        first_institution_third_programme_options: "",
        second_institution_first_programme_id: "",
        second_institution_second_programme_id: "",
        second_institution_third_programme_id: "",
        second_institution_first_programme_session: "",
        second_institution_second_programme_session: "",
        second_institution_third_programme_session: "",
        second_institution_first_programme_options: "",
        second_institution_second_programme_options: "",
        second_institution_third_programme_options: "",
        third_institution_first_programme_id: "",
        third_institution_second_programme_id: "",
        third_institution_third_programme_id: "",
        third_institution_first_programme_session: "",
        third_institution_second_programme_session: "",
        third_institution_third_programme_session: "",
        third_institution_first_programme_options: "",
        third_institution_second_programme_options: "",
        third_institution_third_programme_options: "",
        applicant_accepted_programme_id: "",
        first_institution_first_programme_admission_status: "",
        first_institution_second_programme_admission_status: "",
        first_institution_third_programme_admission_status: "",
        second_institution_first_programme_admission_status: "",
        second_institution_second_programme_admission_status: "",
        second_institution_third_programme_admission_status: "",
        third_institution_first_programme_admission_status: "",
        third_institution_second_programme_admission_status: "",
        third_institution_third_programme_admission_status: "",
        payment_status: "",
        application_status: "",
        applicant_accepted_institution_id: "",
        applicant_in_school: "",
        shs_country: "",
        first_institution_first_programme_campus: "",
        first_institution_second_programme_campus: "",
        first_institution_third_programme_campus: "",
        second_institution_first_programme_campus: "",
        second_institution_second_programme_campus: "",
        second_institution_third_programme_campus: "",
        third_institution_first_programme_campus: "",
        third_institution_second_programme_campus: "",
        third_institution_third_programme_campus: "",
        tertiary_country: "",
        tertiary_name_outside: "",
      };
      this.updateFormData();
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      return {
        "p-invalid": this.v$.formData[field].$invalid && this.submitted,
      };
    },
  },
  watch: {},
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
